import { render, staticRenderFns } from "./CeremonyDownloadLoading.vue?vue&type=template&id=5b2e8b4e"
import script from "./CeremonyDownloadLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./CeremonyDownloadLoading.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports